import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { installGlobalErrorLogging } from '@/lib/logger';
import '@/styles/index.css';

// Antes de montar: erros durante a inicialização também precisam ser capturados.
installGlobalErrorLogging();

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado no index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
